export default "__VITE_ASSET__CepQvLQc__"